export enum TransportadorDocumentType {
    Carteirinha = 1,
    Certificado = 2,
    Extrato = 3,
    RevalidacaoOrdinaria = 4
}
